/**Packages */
import md5 from "blueimp-md5";

/**Helpers */
import { objectIsEmpty } from './utils';

const addEventToDataLayer = function (name = '', eventInfo = {}) {
  const eventName = name && typeof name === 'string' ? { event: name } : {};
  const event = { ...eventName, ...eventInfo };

  window.dataLayer.push(event);
};

/* Removed on 2021/04/14 */
export const trackCustomEventCB = function (baseInfo, extraInfo = {}) {
  if (typeof baseInfo === "object" && !objectIsEmpty(baseInfo)) {
    const baseInfoIsSettedCorrectly = Object.keys(baseInfo).every(elem => {
      return elem === "eventCategory" || elem === "eventAction" || elem === "eventLabel";
    });

    if (baseInfoIsSettedCorrectly) {
      if (typeof extraInfo === "object") {
        const eventInfo = { ...baseInfo, ...extraInfo };

        addEventToDataLayer('customEventCB', eventInfo);
      }
    } else {
      throw new Error(`GTM Event doesn't setted correctly`);
    }
  }
};

export const trackCustomPageview = function() {
  addEventToDataLayer('customPageview');
}

/**
 * 
 * @param {*} cf 
 * @param {*} phone 
 */
export const trackCFAndPhone = function(cf = '', phone = '') {
  if(
    cf
    && phone
    && cf !== ''
    && phone !== ''
  ) {
    /**
     * Added on 2/12/2022
     * 
     * c_mdx = codice fiscale
     * t_mdx = telefono
     */

    window.dataLayer.push({
      c_mdx: md5(cf),
      p_mdx: md5(phone),
    })
  }
}
